import gql from 'graphql-tag'
import { useQuery } from '@apollo/client'
import { apolloWordPressClient } from 'lib/wp/client'

interface Params {
  pageURI: string
  enabled: boolean
}

const query = gql`
  query Page(
    $uri: ID!
  ) {
    page(id: $uri, idType: URI) {
      title
      metaData {
        metaDescription
        metaKeywords
        metaTitle
      }
    }
  }
`

export interface CustomPage {
  title: string
  metaData: {
    metaDescription?: string
    metaKeywords?: string
    metaTitle?: string
  }
}

export const useWordpressPage = ({ pageURI, enabled }: Params) => {
  return useQuery<{ page: CustomPage }>(query, {
    client: apolloWordPressClient,
    variables: {
      uri: pageURI
    },
    context: {
      useGetForQueries: true
    },
    skip: !enabled
  })
}
